import { createContext } from 'react';
import { settings } from 'config';

const AppContext = createContext(settings);
export const AddStudentWizardContext = createContext({ user: {} });

export default AppContext;
